module.exports = __webpack_public_path__ + "img/Button-kosik-2021-08.d7d2f910.png";